import { Object3D, Vector2, Vector3 } from 'three';
import { CHECKBOX_CHECKED_BODY_COLOR, CHECKBOX_CHECKED_TEXT_COLOR, CHECKBOX_CURRENT_BODY_COLOR, CHECKBOX_CURRENT_BORDER_COLOR, CHECKBOX_UNCHECKED_BODY_COLOR, PRIMARY_TEXT_COLOR, WINDOW_SPACER_COLOR } from '../styleConfig';
import { TextComponent, Viewer, ViewerModule, WindowComponent, Tween } from '@verybigthings/vbt-webvr-framework';
import IconButtonComponent from '@verybigthings/vbt-webvr-framework/build/main/ts/components/IconButtonComponent';
export default class TasksProgress extends ViewerModule {
    constructor() {
        super();
        this.addObject(this.text = new TextComponent({
            size: new Vector2(0.7, 0.7),
            pxSize: new Vector2(64, 64).multiplyScalar(window['quality'] === 'very low' ? 1 : 1),
            text: {
                style: { size: `${32 * (window['quality'] === 'very low' ? 1 : 1)}px`, family: 'Nunito', weight: '700', color: PRIMARY_TEXT_COLOR.getStyle() },
                lineHeight: 40 * (window['quality'] === 'very low' ? 1 : 1),
                value: 'Tasks remaining',
                autoWrappingHorizontal: true,
                margin: { bottom: 13 }
            },
            background: { color: WINDOW_SPACER_COLOR.getStyle() }
        }));
        this.text.uiObject.position.set(-2.5, 0.1, 0.01);
        this.levelsProgressWrapper = new Object3D();
        this.uiObject.add(this.levelsProgressWrapper);
    }
    init(numberOfTasks, current) {
        const pos = this.uiObject.position.clone();
        const rot = this.uiObject.rotation.clone();
        const oldParent = this.uiObject.parent;
        this.uiObject.position.set(0, 0, 0);
        this.uiObject.rotation.set(0, 0, 0);
        if (oldParent)
            oldParent.remove(this.uiObject);
        this.uiObject.updateMatrixWorld(true);
        if (!this.background) {
            this.addObject(this.background = new WindowComponent({
                size: new Vector2(4 + numberOfTasks * 0.7, 1),
                background: WINDOW_SPACER_COLOR.getHex(),
                bordRadius: 0.2
            }));
        }
        if (this.levelsProgress && this.levelsProgress.length) {
            this.levelsProgress.forEach(a => this.disposeObject(a));
        }
        this.levelsProgress = [];
        this.text.uiObject.position.set(-2.5, 0.1, 0.01);
        for (let i = 0; i < numberOfTasks; i++) {
            let a;
            this.levelsProgress.push(a = this.addObject(this.getButton(i === current ? 2 : i > current ? 1 : 3)));
            a.uiObject.parent.remove(a.uiObject);
            this.levelsProgressWrapper.add(a.uiObject);
            a.uiObject.position.z += 0.1;
        }
        ViewerModule.adjustObjects(this.levelsProgressWrapper.children, true, 0.2);
        ViewerModule.adjustObjects([this.text.uiObject, this.levelsProgressWrapper], true, 0.2);
        this.levelsProgress.forEach(a => a.uiObject.position.y -= 0.06);
        this.uiObject.position.copy(pos);
        this.uiObject.rotation.copy(rot);
        if (oldParent)
            oldParent.add(this.uiObject);
    }
    getButton(type) {
        let a;
        if (type === 1) {
            a = new WindowComponent({
                size: new Vector2(0.42, 0.42),
                bordRadius: 0.2,
                bordColor: WINDOW_SPACER_COLOR.getHex(),
                background: CHECKBOX_UNCHECKED_BODY_COLOR.getHex(),
                bordWidth: 0.05
            });
        }
        else if (type === 2) {
            a = new WindowComponent({
                size: new Vector2(0.4, 0.4),
                bordRadius: 0.2,
                bordColor: CHECKBOX_CURRENT_BORDER_COLOR.getHex(),
                background: CHECKBOX_CURRENT_BODY_COLOR.getHex(),
                bordWidth: 0.05
            });
        }
        else if (type === 3) {
            a = new IconButtonComponent({
                diameter: 0.48,
                background: CHECKBOX_CHECKED_BODY_COLOR.getStyle(),
                textColor: CHECKBOX_CHECKED_TEXT_COLOR.getStyle(),
                text: ''
            });
        }
        return a;
    }
    flyTo(pos, time = 1000, onComplete) {
        if (Viewer.controls.zController)
            return;
        let flyAnim = new Tween(this.uiObject.position)
            .to(pos.clone(), time)
            .easing(TWEEN.Easing.Linear.None)
            .onUpdate((delta) => {
            this.uiObject.lookAt(this.camera.localToWorld(new Vector3()));
        })
            .onComplete(() => {
            this.uiObject.lookAt(this.camera.localToWorld(new Vector3()));
            onComplete && onComplete();
        })
            .start();
    }
}
